import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import axios from "axios";

const ViewUser = () => {

    const [user, setUser]=useState({
        name:"",
        username:"",
        email:""
    });

    const {id}=useParams();

   useEffect(() => {
    loadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

    const loadUser=async ()=>{
        const result=await axios.get(`https://crud-application-backend-otm5.onrender.com/user/${id}`);
        setUser(result.data);
    }

  return (
   <div className='container'> 

    <div className='row'>
        <div className='col-md-6 offset-md-3 border rounded p-4 mt shadow'>
            <h2 className='text-center m-4'>User Information</h2>
            <div className='card'>
                <div className='card-header'>
                    Details of User: 
                    <ul className='list-group list-group-flush text-start'>
                        <li className='list-group=item'>
                            <b>Name:</b>
                            {user.name}
                        </li>
                         <li className='list-group=item'>
                            <b>User Name:</b>
                            {user.username}
                        </li>
                         <li className='list-group=item'>
                            <b>E-Mail:</b>
                            {user.email}
                        </li>

                    </ul>
                </div>
            </div>

            <Link className='btn btn-primary my-2' to={"/"}>Back To Home</Link>
            
            </div>
            </div>
            </div>
  )
}

export default ViewUser